var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 12.5C7.58333 12.5 8.33333 11.825 8.33333 11C8.33333 10.175 7.58333 9.5 6.66667 9.5C5.75 9.5 5 10.175 5 11C5 11.825 5.75 12.5 6.66667 12.5ZM11.6667 5.75H10.8333V4.25C10.8333 2.18 8.96667 0.5 6.66667 0.5C4.36667 0.5 2.5 2.18 2.5 4.25V5.75H1.66667C0.75 5.75 0 6.425 0 7.25V14.75C0 15.575 0.75 16.25 1.66667 16.25H11.6667C12.5833 16.25 13.3333 15.575 13.3333 14.75V7.25C13.3333 6.425 12.5833 5.75 11.6667 5.75ZM4.08333 4.25C4.08333 2.9675 5.24167 1.925 6.66667 1.925C8.09167 1.925 9.25 2.9675 9.25 4.25V5.75H4.08333V4.25ZM11.6667 14.75H1.66667V7.25H11.6667V14.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2);
export default __webpack_public_path__ + "static/media/group-2.7c3cee5ba021c8aaace9bf6c33587c16.svg";
export { ForwardRef as ReactComponent };